'use client'

import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import Image from 'next/image'
import { FC } from 'react'

import useDevice from '@/hooks/useDevice'

const Contributions: FC = () => {
    const { smScreen, mdScreen } = useDevice()

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Text
                variant={mdScreen ? 'h5' : 'h4'}
                sx={{ mb: 4, width: '100%', textAlign: smScreen ? 'left' : 'center' }}
            >
                See where your contributions go
            </Text>
            <Text
                variant={mdScreen ? 'body2' : 'body1'}
                sx={{ mb: smScreen ? 6 : 9, textAlign: smScreen ? 'left' : 'center' }}
            >
                {smScreen ? (
                    <>
                        We prioritise transparency at every level. Right down to our fees. Dig
                        deeper with climate project impact and quality assessment summaries, while
                        getting the latest project news and updates delivered straight to your
                        inbox. Gain visibility and take control of your climate legacy via our
                        easy-to-use platform.
                    </>
                ) : (
                    <>
                        We prioritise transparency at every level. Right down to our fees.
                        <br />
                        Dig deeper with climate project impact and quality assessment summaries,
                        while getting the latest project news and updates delivered straight to your
                        inbox. Gain visibility and take control of your climate legacy via our
                        easy-to-use platform.
                    </>
                )}
            </Text>
            <Image
                width={smScreen ? 980 : 1960}
                height={smScreen ? 225 : 450}
                src={'/images/contributions.png'}
                alt={'See where your contributions go'}
            />
        </Box>
    )
}

export default Contributions
